/**
 * Mock Nextcloud data for prototype
 */

export type NextcloudFileKind =
  | 'folder'
  | 'markdown'
  | 'text'
  | 'pdf'
  | 'image'
  | 'office'
  | 'unknown'

export interface MockNextcloudFile {
  id: string
  name: string
  path: string
  type: NextcloudFileKind
  size?: number
  modified: string
  etag?: string
  fileId?: string
  /** E2EE encrypted folders */
  isEncrypted?: boolean
  /** Present on files in Shared with me */
  sharedBy?: string
  children?: MockNextcloudFile[]
}

// Mock Nextcloud tree for prototype
export const MOCK_NEXTCLOUD_ROOT: MockNextcloudFile[] = [
  {
    id: 'maater-folder',
    name: 'Maater',
    path: '/Maater',
    type: 'folder',
    modified: '2026-10-15T14:30:00Z',
    fileId: '473438',
    children: [
      {
        id: 'project-notes',
        name: 'project-notes.md',
        path: '/Maater/project-notes.md',
        type: 'markdown',
        size: 2048,
        modified: '2026-10-20T09:15:00Z',
        fileId: '473439',
        etag: 'abc123',
      },
      {
        id: 'research',
        name: 'research',
        path: '/Maater/research',
        type: 'folder',
        modified: '2026-10-18T11:00:00Z',
        fileId: '473440',
        children: [
          {
            id: 'sovereign-tech.md',
            name: 'sovereign-tech.md',
            path: '/Maater/research/sovereign-tech.md',
            type: 'markdown',
            size: 4096,
            modified: '2026-10-18T11:00:00Z',
            fileId: '473441',
          },
        ],
      },
      {
        id: 'meeting-agenda',
        name: 'meeting-agenda.txt',
        path: '/Maater/meeting-agenda.txt',
        type: 'text',
        size: 512,
        modified: '2026-10-22T08:30:00Z',
        fileId: '473442',
      },
    ],
  },
  {
    id: 'documents-folder',
    name: 'Documents',
    path: '/Documents',
    type: 'folder',
    modified: '2026-10-10T10:00:00Z',
    fileId: '473443',
    children: [
      {
        id: 'lightweb-notes',
        name: 'lightweb-notes.md',
        path: '/Documents/lightweb-notes.md',
        type: 'markdown',
        size: 3072,
        modified: '2026-10-10T10:00:00Z',
        fileId: '473444',
      },
      {
        id: 'agm-minutes',
        name: 'agm-minutes.pdf',
        path: '/Documents/agm-minutes.pdf',
        type: 'pdf',
        size: 102400,
        modified: '2026-09-28T16:00:00Z',
        fileId: '473445',
      },
    ],
  },
  {
    id: 'photos-folder',
    name: 'Photos',
    path: '/Photos',
    type: 'folder',
    modified: '2026-09-15T14:00:00Z',
    fileId: '473446',
    children: [
      {
        id: 'architecture-diagram',
        name: 'architecture-diagram.png',
        path: '/Photos/architecture-diagram.png',
        type: 'image',
        size: 204800,
        modified: '2026-09-15T14:00:00Z',
        fileId: '473447',
      },
    ],
  },
  {
    id: 'encrypted-folder',
    name: 'Encrypted',
    path: '/Encrypted',
    type: 'folder',
    modified: '2026-09-01T12:00:00Z',
    fileId: '473448',
    isEncrypted: true,
    children: [],
  },
]

// Mock shared files (Shared with me)
export const MOCK_NEXTCLOUD_SHARED: MockNextcloudFile[] = [
  {
    id: 'shared-collab-doc',
    name: 'collaboration-doc.md',
    path: '/shared/collaboration-doc.md',
    type: 'markdown',
    size: 1536,
    modified: '2026-10-23T15:30:00Z',
    fileId: '473449',
    sharedBy: 'Dana Koots',
  },
  {
    id: 'shared-project-brief',
    name: 'project-brief.pdf',
    path: '/shared/project-brief.pdf',
    type: 'pdf',
    size: 512000,
    modified: '2026-10-21T09:00:00Z',
    fileId: '473450',
    sharedBy: 'Dana Koots',
  },
]

// Mock shares created by user
export const MOCK_NEXTCLOUD_SHARES_OUT: MockNextcloudFile[] = [
  {
    id: 'shared-out-tech-notes',
    name: 'technical-notes.md',
    path: '/Maater/technical-notes.md',
    type: 'markdown',
    size: 2560,
    modified: '2026-10-19T14:00:00Z',
    fileId: '473451',
  },
]

export function mockNextcloudMimeType(kind: NextcloudFileKind): string {
  switch (kind) {
    case 'folder':
      return 'httpd/unix-directory'
    case 'markdown':
      return 'text/markdown'
    case 'text':
      return 'text/plain'
    case 'pdf':
      return 'application/pdf'
    case 'image':
      return 'image/png'
    case 'office':
      return 'application/vnd.oasis.opendocument.text'
    default:
      return 'application/octet-stream'
  }
}

export function isNextcloudFileImportable(kind: NextcloudFileKind): boolean {
  return kind === 'markdown' || kind === 'text'
}
